import { Tracker, TrackingEvent, TrackerLogger } from '../Tracking.events';

export class PlausibleTracker implements Tracker {
	plausible: any;
	constructor(plausible: any) {
		this.plausible = plausible;
	}

	sendEvent(event: TrackingEvent) {
		const { type } = event;
		TrackerLogger.debug(`Plausible: `, event);
		this.plausible.trackEvent(type);
	}
}
